import jui from '@ui/styles.css?inline';
import base from './styles/base.css?inline';
import board from './styles/board.css?inline';
import bugReport from './styles/bugReport.css?inline';
import help from './styles/help.css?inline';
import settings from './styles/settings.css?inline';
import ux from './styles/ux.css?inline';
import tracker from './styles/tracker.css?inline';
import { makeRoomCss, onMakeRoomChange } from './config';

/** All widget CSS — the shared library sheet first, then the widget's own — scoped under `.jaiora-bugs` by the build (widget/build/scopeCss.ts). */
export const WIDGET_CSS = [jui, base, bugReport, ux, settings, board, help, tracker].join('\n');

const STYLE_ID = 'jaiora-bugs-style';
const ROOM_ID = 'jaiora-bugs-room';

function syncRoom(): void {
  const css = makeRoomCss();
  let el = document.getElementById(ROOM_ID);
  if (!css) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement('style');
    el.id = ROOM_ID;
    document.head.appendChild(el);
  }
  el.textContent = css;
}

let installed = false;

/**
 * Once per page. The widget sheet goes first in `<head>`: a host rule of the same specificity (`.ui-v2 .btn` against the
 * scoped `.jaiora-bugs .btn`) comes later and wins, so host theme hooks keep working.
 */
export function injectStyles(): void {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  if (!document.getElementById(STYLE_ID)) {
    const el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = WIDGET_CSS;
    document.head.insertBefore(el, document.head.firstChild);
  }
  syncRoom();
  onMakeRoomChange(syncRoom);
}
